import setGlobalState from '../../redux/setGlobalState';

export const loaderPopupDismissRef = {current: null as (() => void) | null};

export function dismissLoaderPopupAI() {
    if(loaderPopupDismissRef.current) {
        loaderPopupDismissRef.current();
        return;
    }
    setGlobalState('ui.show.isOpenAiLoaderPopup', false);
}
